import React from "react";
import css from "./AppIcon.module.css";
import {appicon} from "Assets";


export default function AppIcon(props){
    const {labeled=true,clickable=true}=props;
    const Tag=clickable?"a":"div";
    return (
        <Tag 
            className={`${clickable?"button":""} ${css.appicon} ${props.className||""}`}
            style={props.style} 
            {...(clickable&&{
                href:"#",
                onClick:()=>{document.title="Vritra"},
            })}
        >
            <img alt="logo" className={css.icon} draggable={false} src={appicon(mainColor)}/>
            {labeled&&<h3 className={css.name}>vritra</h3>}
        </Tag>
    )
}
